if (window.Cypress) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ =
        window.parent.__REACT_DEVTOOLS_GLOBAL_HOOK__;
}
